<template>
  <div class="permission-controls">
    <el-button
      class="styles"
      v-for="(action, index) of actions"
      :key="index"
      :type="type"
      :size="size"
      @click="clicked(action.methodName)"
      v-if="action.visible"
      :disabled="action.disabled"
    >
      {{ action.name }}
    </el-button>
  </div>
</template>

<script>
import {deepCopy} from "../common/base";
import {debounce} from "xe-utils";
import store from "../store";

export default {
  name: "PermissionButton",
  props: {
    type: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "mini"
    },
    params: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: String,
      default: "top"
    },
    visible_list: {
      type: Array,
      default: () => []
    },
    disabled_list: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      actions: [] // 初始化为一个空数组
    };
  },
  watch: {
    visible_list(newValue) {

      this.flush()
    },
    disabled_list(newValue) {

      this.flush()
    }
  },

  mounted() {
    this.flush()
  },
  methods: {
    clicked: debounce(function (methodName) {
      if (this.params && JSON.stringify(this.params) !== "{}" && Object.keys(this.params).length > 0) {

        this.$emit("CALL_METHOD", methodName, deepCopy(this.params));
      } else {

        this.$emit("CALL_METHOD", methodName);
      }
    }, 500, {leading: true}),
    getCodeByDesc(desc) {
      if (desc === "top") {
        return 0;
      } else if (desc === "column") {
        return 1;
      } else if (desc === "bottom") {
        return 2;
      }
    },
    flush() {
      const allActions = store.getters['permission/getCurrentMenu']['actionPoints'];
      const idx = this.getCodeByDesc(this.position);
      const filteredActions = allActions.filter(item => item.position === idx);

      // 按照sortOrder排序，如果没有sortOrder属性，则按原有顺序
      const sortedActions = filteredActions.sort((a, b) => {
        const sortA = a.sortOrder || 0;
        const sortB = b.sortOrder || 0;
        return sortA - sortB;
      });

      this.actions = sortedActions.map((item, index) => {
        const isVisible = [true, false].includes(this.visible_list[index]) ? this.visible_list[index] : true;
        const isDisabled = [true, false].includes(this.disabled_list[index]) ? this.disabled_list[index] : false;

        return {
          ...item,
          visible: isVisible,
          disabled: isDisabled,
        };
      });
    }
  }
};
</script>

<style scoped>
.permission-controls {
  display: flex;
  flex-direction: row; /* 可以根据需要调整为列 */
}

.component {
  margin-right: 5px;
}

.styles {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PermissionButton.vue